import React from 'react';
import PropTypes from 'prop-types';
import I18nStore from 'stores/I18nStore';
import { Link } from 'gutenberg-ui';

const ContactUsNode = ({ title }) => {
  const locale = I18nStore.getState().currentLocale;
  return (
    <div className="aa-help-node-root" data-cy="sidebar-contact-us">
      <Link href={`/${locale}/contact`}>{title}</Link>
    </div>
  );
};

ContactUsNode.propTypes = {
  title: PropTypes.string,
};

export default ContactUsNode;
